import { Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import movimientoInventarioPdf from "../../../../Pdf/movimientoInventarioPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalMovimientoInventarioPdf extends Component {
  state = {
    loading: false,
    pdf: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarDatosPdf();
    }
  }

  async consultarDatosPdf() {
    this.setState({ loading: true });
    axios
      .post(
        "movimientosInventario/datosPdfMovimientoInventario",
        {
          movimientoId: this.props.movimientoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const generador = movimientoInventarioPdf(res.data, {
            mostrarCostos: !!this.props.mostrarCostos,
          });
          const pdf = pdfMake.createPdf(generador);
          this.setState({ loading: false, pdf }, () => {
            pdf.open({}, window.frames["MovimientoInventarioPdfIframe"]);
          });
        } else {
          message.error("No se encontraron datos del movimiento");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al generar el documento");
        this.setState({ loading: false });
      });
  }

  descargarPdf() {
    if (this.state.pdf) {
      const folio = this.props.movimientoFolio || "Documento";
      this.state.pdf.download(`MovimientoInventario_${folio}.pdf`);
    }
  }

  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    return (
      <ModalItem
        title="Vista Previa Movimiento de Inventario"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.handleCancel}
        paddingTop
        width={900}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 10,
          }}
        >
          <Space>
            <ButtonItem
              icon={<DownloadOutlined />}
              type="primary"
              onClick={() => this.descargarPdf()}
            >
              Descargar PDF
            </ButtonItem>
            <ButtonItem danger onClick={this.handleCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>

        <iframe
          title="Movimiento Inventario PDF"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="MovimientoInventarioPdfIframe"
          name="MovimientoInventarioPdfIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalMovimientoInventarioPdf);
